(function () {
  var attributionKeys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];

  function getAttribution() {
    var attribution = {};
    attributionKeys.forEach(function (key) { attribution[key] = ''; });

    try {
      var stored = window.sessionStorage.getItem('aoy_original_inquiry_attribution');
      if (stored) attribution = Object.assign(attribution, JSON.parse(stored) || {});
    } catch (error) {
      // Attribution is best-effort and must never prevent contact submission.
    }

    var params = new URLSearchParams(window.location.search);
    attributionKeys.forEach(function (key) {
      if (params.has(key)) attribution[key] = params.get(key) || '';
      if (typeof attribution[key] !== 'string') attribution[key] = '';
    });
    return attribution;
  }

  function toggleOriginalHelper(select, helper) {
    if (!select || !helper) return;
    helper.hidden = select.value !== 'Original Artwork';
  }

  function setActiveContactTab(root, tabName, options) {
    var settings = options || {};
    var activeName = tabName === 'special' ? 'special' : 'general';
    var activeTab = null;
    var activePanel = null;

    root.querySelectorAll('[data-aoy-contact-tab]').forEach(function (tab) {
      var selected = tab.dataset.aoyContactTab === activeName;
      tab.setAttribute('aria-selected', selected ? 'true' : 'false');
      tab.tabIndex = selected ? 0 : -1;
      if (selected) activeTab = tab;
    });

    root.querySelectorAll('[data-aoy-contact-panel]').forEach(function (panel) {
      var selected = panel.dataset.aoyContactPanel === activeName;
      panel.hidden = !selected;
      if (selected) activePanel = panel;
    });

    root.dataset.aoyContactActiveTab = activeName;

    if (settings.updateHistory && window.history && typeof window.history.replaceState === 'function') {
      var destination = window.location.pathname + window.location.search;
      if (activeName === 'special') destination += '#special-project-inquiry';
      window.history.replaceState(null, '', destination);
    }

    if (settings.focusTab && activeTab) activeTab.focus();
    if (settings.scrollToPanel && activePanel) {
      window.requestAnimationFrame(function () {
        activePanel.scrollIntoView({ block: 'start' });
      });
    }
  }

  function initContactTabs(root) {
    var tabList = root.querySelector('[data-aoy-contact-tabs]');
    var formColumn = root.querySelector('.aoy-contact-page__form-column');
    var specialPanel = root.querySelector('[data-aoy-contact-panel="special"]');
    if (!tabList || !formColumn || !specialPanel) return;

    formColumn.appendChild(specialPanel);

    var tabs = Array.prototype.slice.call(tabList.querySelectorAll('[data-aoy-contact-tab]'));
    tabs.forEach(function (tab, index) {
      tab.addEventListener('click', function () {
        setActiveContactTab(root, tab.dataset.aoyContactTab, { updateHistory: true });
      });

      tab.addEventListener('keydown', function (event) {
        var nextIndex = null;
        if (event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
        if (event.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = tabs.length - 1;
        if (nextIndex === null) return;
        event.preventDefault();
        setActiveContactTab(root, tabs[nextIndex].dataset.aoyContactTab, {
          updateHistory: true,
          focusTab: true
        });
      });
    });

    var specialRequested = window.location.hash === '#special-project-inquiry';
    var specialHasError = Boolean(specialPanel.querySelector('[data-aoy-special-form-errors="true"]'));
    setActiveContactTab(root, specialRequested || specialHasError ? 'special' : 'general', {
      scrollToPanel: specialRequested
    });
  }

  function validateField(field) {
    var errorId = field.getAttribute('aria-describedby');
    var error = errorId ? document.getElementById(errorId) : null;
    var valid = field.validity.valid;
    field.setAttribute('aria-invalid', valid ? 'false' : 'true');
    if (error) error.hidden = valid;
    return valid;
  }

  function validateForm(form) {
    var firstInvalid = null;
    form.querySelectorAll('input[required], textarea[required]').forEach(function (field) {
      if (!validateField(field) && !firstInvalid) firstInvalid = field;
    });
    if (firstInvalid) {
      firstInvalid.focus();
      firstInvalid.reportValidity();
      return false;
    }
    return true;
  }

  function setSubmitState(form, sending) {
    var button = form.querySelector('#studio-contact-submit');
    var label = button && button.querySelector('[data-studio-contact-submit-label]');
    var arrow = button && button.querySelector('[data-studio-contact-submit-arrow]');
    if (!button || !label) return;
    button.disabled = sending;
    button.setAttribute('aria-disabled', sending ? 'true' : 'false');
    form.setAttribute('aria-busy', sending ? 'true' : 'false');
    label.textContent = sending ? 'Sending…' : 'Send Message';
    if (arrow) arrow.hidden = sending;
  }

  function showError(form) {
    var error = form.querySelector('#studio-contact-error');
    if (!error) return;
    error.hidden = false;
    error.focus();
  }

  function dispatchSuccess(root, reason) {
    if (root.dataset.aoyContactEventSent === 'true') return;
    root.dataset.aoyContactEventSent = 'true';
    var attribution = getAttribution();
    document.dispatchEvent(new CustomEvent('artofyost:contact_form_submitted', {
      detail: {
        page_path: window.location.pathname,
        contact_reason: reason || 'General Question',
        utm_source: attribution.utm_source,
        utm_medium: attribution.utm_medium,
        utm_campaign: attribution.utm_campaign,
        utm_content: attribution.utm_content,
        utm_term: attribution.utm_term
      }
    }));
  }

  function completeSubmission(root, form, reason) {
    if (root.dataset.aoyContactCompleted === 'true') return;
    root.dataset.aoyContactCompleted = 'true';
    root.classList.add('aoy-contact-page--success');
    var formState = form.querySelector('[data-studio-contact-form-state]');
    var success = form.querySelector('#studio-contact-success');
    var error = form.querySelector('#studio-contact-error');
    if (formState) formState.hidden = true;
    if (error) error.hidden = true;
    if (success) {
      success.hidden = false;
      success.dataset.aoyContactPrimarySuccess = 'true';
      success.focus();
    }
    dispatchSuccess(root, reason);
  }

  function submitForm(root, form, event) {
    event.preventDefault();
    if (root.dataset.aoyContactCompleted === 'true' || form.dataset.aoySubmitting === 'true') return;
    if (!validateForm(form)) return;

    var error = form.querySelector('#studio-contact-error');
    var reason = form.querySelector('#studio-contact-reason');
    if (error) error.hidden = true;
    form.dataset.aoySubmitting = 'true';
    setSubmitState(form, true);

    fetch(form.action, {
      method: (form.method || 'post').toUpperCase(),
      body: new FormData(form),
      credentials: 'same-origin',
      headers: { Accept: 'text/html' },
      redirect: 'follow'
    }).then(function (response) {
      if (!response.ok) throw new Error('Contact request failed');
      return response.text();
    }).then(function (html) {
      var responseDocument = new DOMParser().parseFromString(html, 'text/html');
      var confirmed = responseDocument.querySelector('#studio-contact-success[data-aoy-contact-primary-success="true"]');
      if (!confirmed) throw new Error('Contact success was not confirmed by Shopify');
      completeSubmission(root, form, reason ? reason.value : 'General Question');
    }).catch(function () {
      showError(form);
    }).finally(function () {
      delete form.dataset.aoySubmitting;
      setSubmitState(form, false);
    });
  }

  function initContactPage(root) {
    if (!root || root.dataset.aoyContactReady === 'true') return;
    root.dataset.aoyContactReady = 'true';
    initContactTabs(root);
    var form = root.querySelector('#studio-contact-form');
    if (!form) return;

    var reason = form.querySelector('#studio-contact-reason');
    var helper = form.querySelector('#studio-contact-original-helper');
    toggleOriginalHelper(reason, helper);
    if (reason) reason.addEventListener('change', function () { toggleOriginalHelper(reason, helper); });

    form.querySelectorAll('input[required], textarea[required]').forEach(function (field) {
      field.addEventListener('input', function () {
        if (field.getAttribute('aria-invalid') === 'true') validateField(field);
      });
      field.addEventListener('blur', function () { validateField(field); });
    });

    form.addEventListener('submit', function (event) { submitForm(root, form, event); });

    var serverSuccess = form.querySelector('#studio-contact-success[data-aoy-contact-primary-success="true"]');
    if (serverSuccess) {
      completeSubmission(root, form, serverSuccess.dataset.contactReason || (reason && reason.value));
    }
  }

  function initAll() {
    document.querySelectorAll('.aoy-contact-page[data-aoy-page="contact"]').forEach(initContactPage);
  }

  function syncTabsToHash() {
    document.querySelectorAll('.aoy-contact-page[data-aoy-page="contact"]').forEach(function (root) {
      setActiveContactTab(root, window.location.hash === '#special-project-inquiry' ? 'special' : 'general', {
        scrollToPanel: window.location.hash === '#special-project-inquiry'
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
  window.addEventListener('hashchange', syncTabsToHash);
})();
